import { Component, ViewChild, OnInit } from '@angular/core';
import { ValidateComponent } from '../../components/common/validateComponent/validate.component';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../../services/registration.service';
import { Subscription } from 'rxjs';
import { TenderTeamMemberRegistrationModel } from '../../models/registration/registration.models';
import { GetTeamMemberDetailsDto } from '../../models/tender.team.members/tender.team.member.models';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
    selector: 'registration/acceptTeamInvite',
    template: require('./accept.team.invite.component.html')
})
export class AcceptTeamInvitationComponent extends ValidateComponent implements OnInit {
    postcode: string;
    request: TenderTeamMemberRegistrationModel;
    routeParamsSub: Subscription;

    @BlockUI() blockUi: NgBlockUI;

    emailVerified: boolean;
    tokenError: boolean;

    @ViewChild('validateForm', { static: false }) currentForm;

    constructor(private readonly registrationService: RegistrationService, private readonly router: Router, private readonly route: ActivatedRoute) {
        super();

        this.formErrors = {
            'firstName': '',
            'lastName': '',
            'emailAddress': '',
            'password': '',
            'confirmPassword': '',
            'companyName': '',
        };

        this.validationMessages = {
            'firstName': {
                'required': 'First Name is required.'
            },
            'lastName': {
                'required': 'Last Name is required.'
            },
            'emailAddress': {
                'required': 'Email address is required.',
                'pattern': 'Must be a valid email address.'
            },
            'password': {
                'required': 'Password is required.',
                'pattern': 'Password is not valid.'
            },
            'companyName': {
                'required': 'Company Name is required.'
            },
            'confirmPassword': {
                'validateEqual': 'Passwords do not match.'
            }
        }
    }

    ngOnInit(): void {
        $('#t-and-c-modal').modal();
        $('#t-and-c-modal').modal('hide');

        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            var token = params['token'];

            this.registrationService.getDetailsFromToken(token)
                .subscribe((response: GetTeamMemberDetailsDto) => {

                    if (response.tokenError) {
                        this.tokenError = true;
                        return;
                    }

                    this.emailVerified = response.emailVerified;
                    this.request = new TenderTeamMemberRegistrationModel(response);
                    this.request.token = token;

                    if (response.emailVerified) {
                        this.request.acceptedTermsAndConditions = true;
                        this.submitRequest();
                    }
                });
        });
    }

    onSubmit() {
        this.removeErrors();

        var errors = false;

        if (!this.showErrors(true)) {
            errors = true;
        }

        if (this.request.password !== this.request.confirmPassword) {
            this.formErrors['confirmPassword'] = 'Passwords do not match.';
            errors = true;
        }

        if (errors) {
            return;
        }

        this.submitRequest();
    }

    private submitRequest() {
        if (!this.request.acceptedTermsAndConditions) {
            return;
        }

        this.blockUi.start();
        this.registrationService.confirmTeamMemberDetails(this.request)
            .subscribe(() => {
                this.router.navigateByUrl('/registration/thanks');
            },
                () => { this.blockUi.stop(); },
                () => { this.blockUi.stop(); }
            );
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/accept.team.invite.component.ts